// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { floppyDiskThreeDots16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-floppy-disk-three-dots': IconFloppyDiskThreeDots;
    }
}

/**
 * The icon component for the 'floppyDiskThreeDots' icon
 */
export class IconFloppyDiskThreeDots extends IconSvg {
    public constructor() {
        super(floppyDiskThreeDots16X16);
    }
}

registerIconSvg('icon-floppy-disk-three-dots', IconFloppyDiskThreeDots);
export const iconFloppyDiskThreeDotsTag = 'nimble-icon-floppy-disk-three-dots';
